<div class="attendance-calendar" #calendarContainer tabindex="0" role="application" aria-label="Attendance Calendar">
  <!-- Calendar Header -->
  <div class="calendar-header">
    <div class="header-content">
      <h3 class="calendar-title">Calendar</h3>
      <div class="calendar-nav">
        <button class="nav-btn" (click)="navigateMonth('prev')" type="button" aria-label="Previous month">
          <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 1L5 7L11 13" stroke="#15172E" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <span class="month-year">{{ getMonthYearDisplay() }}</span>
        <button class="nav-btn" (click)="navigateMonth('next')" type="button" aria-label="Next month">
          <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 1L13 7L7 13" stroke="#15172E" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Calendar Grid -->
  <div class="calendar-grid">
    <!-- Weekday Headers -->
    <div class="calendar-weekdays">
      <div class="weekday" *ngFor="let weekday of weekdays; trackBy: trackByIndex">{{ weekday }}</div>
    </div>
    
    <!-- Calendar Days -->
    <div class="calendar-days">
      <div 
        *ngFor="let day of calendarDays; let i = index; trackBy: trackByIndex" 
        class="calendar-day"
        [class.disabled]="day.isDisabled"
        [class.today]="day.isToday"
        [class.selected]="day.isSelected"
        (click)="onDayClick(day)"
        [attr.aria-label]="'Day ' + day.day + (day.isToday ? ', today' : '') + (day.isSelected ? ', selected' : '')"
        role="button"
        [attr.tabindex]="day.isDisabled ? -1 : 0">
        <span class="day-number">{{ day.day }}</span>
        <span class="day-hours" *ngIf="day.hours && day.hours !== '0:00'">{{ day.hours }}</span>
      </div>
    </div>
  </div>
</div>
